import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { StyledButton } from "../../../../components/styled/styled-components";
import { OrderDetail } from "../../../../interfaces/interfaces";
import { PaymentOption } from "../../../check-out/payment-selection/sendPaymentSelection";

export enum ResponseStatusTypes {
  "error",
  "success_unpaid",
  "success_paid",
  "success_confirming",
  "success_unavailable",
}

export const renderOrderStatus = (orderStatus: string) => {
  if (!orderStatus) return <LoadingSpinner />;

  try {
    return (
      <p className="order-status">
        {orderStatus.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
          return str.toUpperCase();
        })}
      </p>
    );
  } catch (err) {
    return <p className="order-status">orderStatus</p>;
  }
};

export const renderTrackingNumbers = (order: OrderDetail) => {
  if (order.track_numbers.length === 0) return <div>N/A</div>;

  return order.track_numbers.map((number: any) => {
    if (number.trackingNumber.includes("NOW COURIERS")) {
      const barcode = number.trackingNumber.substring(13);
      const trackingURL =
        "https://www.nowcouriers.co.nz/now/servlet/ITNG_TAndTServlet?page=1&VCCA=Enabled&Key_Type=CustomerLabel&customer_number=FASHBIZ&consignment_id=" +
        barcode;

      return (
        <div key={number.trackingNumber}>
          <a
            href={trackingURL}
            style={{ textDecoration: "underline" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to track {number.trackingNumber}
          </a>
        </div>
      );
    } else {
      return (
        <div key={number.trackingNumber}>
          <a
            href={number.trackingUrl}
            style={{ textDecoration: "underline" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to track {number.trackingNumber}
          </a>
        </div>
      );
    }
  });
};

export const renderPaymentNZ = (order: OrderDetail) => {
  const isPaymentOnline = order.payment_method === PaymentOption.payOnline;

  if (!isPaymentOnline || order.payment_status === "unavailable") return null;
  if (order.payment_status === "paid") {
    return (
      <Tooltip content="Your order has been paid successfully" position="left">
        <span className="success-payment">Order Paid</span>
      </Tooltip>
    );
  }
  if (order.payment_status === "confirming") {
    return (
      <Tooltip content="Your payment is being processed in our systems" position="left">
        <span className="success-confirming">Confirming</span>
      </Tooltip>
    );
  }
  if (order.payment_status === "unpaid") {
    return (
      <a href={`/payment-form/${order.id}`} target="_blank" rel="noreferrer">
        <StyledButton success className="pay-order-button">
          Pay order
        </StyledButton>
      </a>
    );
  }
};

export const renderPayment = (
  responseStatus: ResponseStatusTypes | null,
  paymentSessionURL: string | null,
) => {
  if (responseStatus === ResponseStatusTypes.success_unpaid) {
    return (
      <a href={paymentSessionURL || ""} target="_blank" rel="noreferrer">
        <StyledButton success className="pay-order-button">
          Pay order
        </StyledButton>
      </a>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_paid) {
    return (
      <Tooltip content="Your order has been paid successfully" position="left">
        <span className="success-payment">Order Paid</span>
      </Tooltip>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_confirming) {
    return (
      <Tooltip content="Your payment is being processed in our systems" position="left">
        <span className="success-confirming">Confirming</span>
      </Tooltip>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_unavailable) {
    return <></>;
  }
  if (responseStatus === ResponseStatusTypes.error) {
    return (
      <StyledButton info disabled>
        Pay Order
      </StyledButton>
    );
  }
};
